import { render, staticRenderFns } from "./cut.vue?vue&type=template&id=0c28c1b4&scoped=true&"
import script from "./cut.vue?vue&type=script&lang=js&"
export * from "./cut.vue?vue&type=script&lang=js&"
import style0 from "./cut.vue?vue&type=style&index=0&id=0c28c1b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c28c1b4",
  null
  
)

export default component.exports